/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Emailchancenwerk1Inputs */

const de__field_emailchancenwerk1 = /** @type {(inputs: _Field_Emailchancenwerk1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail (Chancenwerk)`)
};

/**

* @param {_Field_Emailchancenwerk1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_emailchancenwerk1 = /** @type {((inputs?: _Field_Emailchancenwerk1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Emailchancenwerk1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_emailchancenwerk1(inputs)
});
export { _field_emailchancenwerk1 as "_field_emailChancenwerk" }